const i18n = require('@/lang/index')
const cima = require('@/regulator/cima.js')
const svg = require('@/regulator/svg.js')
const country = require('@/constants/country.js')
const countryCodeEnum = country.countryCodeEnum
const regulator = {
  cima,
  svg,
}

module.exports = {
  cpUrl: 'https://myaccount.vtmarkets.com.cn',
  info: {
    copyright: '2017',
    fullName: 'VT Markets',
    entityName: 'VT Markets Limited',
    getUrl(reg) {
      return reg ? regulator[reg].info.url : ''
    },
    getUrlGCN(reg) {
      return reg ? regulator[reg].info.urlGcn : ''
    },
    getUrlCn(reg) {
      return reg ? regulator[reg].info.urlCn : ''
    },
    getUrlTw(reg) {
      return reg ? regulator[reg].info.urlTw : ''
    },
    getUrlId(reg) {
      return reg ? regulator[reg].info.urlId : ''
    },
    getUrlEu(reg) {
      return reg ? regulator[reg].info.urlEu : ''
    },
    getUrlIT(reg) {
      return reg ? regulator[reg].info.urlIt : ''
    },
    getUrlIr(reg) {
      return reg ? regulator[reg].info.urlIr : ''
    },
    getUrlIrPro(reg) {
      return reg ? regulator[reg].info.urlIrPro : ''
    },
    getUrlMy(reg) {
      return reg ? regulator[reg].info.urlMy : ''
    },
    getUrlRu(reg) {
      return reg ? regulator[reg].info.urlRu : ''
    },
    getUrlIraq(reg) {
      return reg ? regulator[reg].info.urlIraq : ''
    },
    getUrlVn(reg) {
      return reg ? regulator[reg].info.urlVn : ''
    },
    getUrlFrEu(reg) {
      return reg ? regulator[reg].info.urlFrEu : ''
    },
    getUrlJa(reg) {
      return reg ? regulator[reg].info.urlJa : ''
    },
    getUrlKh(reg) {
      return reg ? regulator[reg].info.urlKh : ''
    },
    getMap(reg) {
      return regulator[reg].info.map
    },
    getMapIran(reg) {
      return regulator[reg].info.mapIran
    },
    getAddress(reg) {
      return regulator[reg].info.address
    },
    getAddressIran(reg) {
      return regulator[reg].info.addressIran
    },
    getEmail(reg) {
      return reg ? regulator[reg].info.email : ''
    },
    getName(reg) {
      return reg ? regulator[reg].info.name : ''
    },
    getNameIran(reg) {
      return reg ? regulator[reg].info.nameIran : ''
    },
    getDepositEmail(reg) {
      return reg ? regulator[reg].info.depositEmail : ''
    },
    getWithdrawalEmail(reg) {
      return reg ? regulator[reg].info.withdrawalEmail : ''
    },
  },
  menu: [
    {
      name: 'menu.dashboard',
      path: '/home',
      icon: 'menu-dashboard',
      activeIcon: require('@/assets/uploads/menu/menu-dashboard.png'),
    },
    {
      name: 'menu.ibReport',
      path: '/ibReport',
      icon: 'menu-report',
      activeIcon: require('@/assets/uploads/menu/menu-report.png'),
    },
    {
      name: 'menu.iblevel',
      path: '/iblevel',
      icon: 'menu-levels',
      activeIcon: require('@/assets/uploads/menu/menu-levels.png'),
    },
    {
      name: 'menu.ibAccs',
      path: '/ibAccounts',
      icon: 'menu-ib-accounts',
      activeIcon: require('@/assets/uploads/menu/menu-ib-accounts.png'),
    },
    {
      name: 'menu.payHistory',
      path: '/RebatePaymentHistory',
      icon: 'menu-transfer-history',
      activeIcon: require('@/assets/uploads/menu/menu-transfer-history.png'),
    },
    {
      name: 'menu.ibProfile',
      path: '/settings',
      icon: 'menu-profile',
      activeIcon: require('@/assets/uploads/menu/menu-profile.png'),
    },
    {
      name: 'menu.refLinks',
      path: '/ReferralLinks',
      icon: 'menu-links',
      activeIcon: require('@/assets/uploads/menu/menu-links.png'),
    },
    {
      name: 'menu.contactUs',
      path: '/contactUs',
      icon: 'menu-contact',
      activeIcon: require('@/assets/uploads/menu/menu-contact.png'),
      appHidden: true,
    },
  ],
  accountTypeMaps: {
    0: 'ALL', // "", mt4
    1: 'Standard STP', // standardSTP, mt4
    2: 'Raw ECN', // rawECN, mt4
    3: 'Standard STP & Binary Options', // "", mt4
    4: 'Raw ECN & Binary Options', // "", mt4
    5: 'Binary Options Only', // "", mt4
    6: 'Swap-free Standard STP', // swapFreeStandardSTP, mt4
    7: 'Swap-free Raw ECN', // swapFreeRawECN, mt4
    8: 'Raw PRO ECN', // proECN, mt4
    9: 'VIP STP', // 9, mt4
    10: 'PAMM', // PAMM, mt4
    101: 'Standard STP', // "", mt5
    11: 'Net STP', // "", mt5
    12: 'Net ECN', // "", mt5
    13: 'Standard STP', // standardSTP, mt5
    14: 'Raw ECN', // rawECN, mt5
    15: 'Swap-free Standard STP', // swapFreeStandardSTP, mt5
    16: 'Swap-free Raw ECN', // swapFreeRawECN, mt5
    17: 'Raw PRO ECN', // proECN, mt5
    18: 'VIP STP', // 9, mt5
    19: 'Cent STP', // STANDARD_STP_CENT, mt4
    20: 'Cent Swap-free STP', // ISLAMIC_STP_CENT, mt4
    22: 'Cent ECN', // RAW_ECN_CENT, mt4
    23: 'Cent Swap-free ECN', // ISLAMIC_ECN_CENT, mt4
    24: 'Cent STP', // STANDARD_STP_CENT, mt5
    25: 'Cent Swap-free STP', // ISLAMIC_STP_CENT, mt5
    26: 'Cent ECN', // RAW_ECN_CENT, mt5
    27: 'Cent Swap-free ECN', // ISLAMIC_ECN_CENT, mt5
    28: 'PAMM', // PAMM, mt5
    39: 'Swap-free VIP STP', // swapFreeVipStp, mt4
    40: 'VIP STP Cent', // vipStpCent, mt4
    41: 'Swap-free VIP STP Cent', // swapFreeVipStpCent, mt4
    42: 'Swap-free VIP STP', // swapFreeVipStp, mt5
    43: 'VIP STP Cent', // vipStpCent, mt5
    44: 'Swap-free VIP STP Cent', // swapFreeVipStpCent, mt5,
    99: 'MTS ST',
    100: 'MTS Hedge STP',
    102: 'MTS Swap free STP',
    103: 'MTS Swap free ECN',
    104: 'MTS Standard STP Cent',
    105: 'MTS Swap free STP Cent',
    106: 'MTS Pro Standard',
    107: 'MTS Raw ECN Cent',
    108: 'MTS Swap free ECN Cent',
    109: 'MTS ECN',
    110: 'MTS Hedge ECN',
    111: 'MTS PRO ECN',
    112: 'MTS Swap free VIP STP',
    113: 'MTS Swap free VIP STP Cent',
    114: 'MTS VIP STP Cent',
    115: 'MTS Hedge VIP STP',
    153: 'Swap-free Raw PRO ECN', // proSwapFreeECN, mt5
  },
  country_transferOptions: [
    {
      id: 2,
      value: 'common.country.international',
    },
  ],
  chartColor: ['#0051ff', '#002981', '#99b9ff', '#00f0ff', '#ccfcff'],
  getCheckMethodMinAmount(reg) {
    return reg ? regulator[reg].withdrawSetup.checkMethodMinAmount : false
  },
  getCancelWithdraw(reg) {
    return reg ? regulator[reg].withdrawSetup.cancelWithdraw : false
  },
  withdrawalDefaultAmountMin: 40,
  usdRateFromApiCurrencyList: ['USC'], // currencies whitch calling api to get rate (USD to specific currency)
  islamicAccountTypeMaps: {
    6: 'STP Cent Islamic', // swapFreeStandardSTP, mt4
    7: 'Raw ECN Islamic', // swapFreeRawECN, mt4
    15: 'STP Cent Islamic', // swapFreeStandardSTP, mt5
    16: 'ECN Cent Islamic', // swapFreeRawECN, mt5
    20: 'STP Cent Islamic', // ISLAMIC_STP_CENT, mt4
    23: 'ECN Cent Islamic', // ISLAMIC_ECN_CENT, mt4
    25: 'STP Cent Islamic', // ISLAMIC_STP_CENT, mt5
    27: 'ECN Cent Islamic', // ISLAMIC_ECN_CENT, mt5,
    39: 'VIP STP Islamic', // swapFreeVipStp, mt4,
    41: 'VIP Cent Islamic', // swapFreeVipStpCent, mt4
    44: 'VIP Cent Islamic', // swapFreeVipStpCent, mt5
    102: 'MTS STP Standard Islamic',
    103: 'MTS Raw ECN Islamic',
    105: 'MTS STP Cent Islamic',
    108: 'MTS ECN Cent Islamic',
    112: 'MTS VIP STP Islamic',
    113: 'MTS VIP Cent Islamic',
    153: 'Raw PRO ECN Islamic', // proSwapFreeECN, mt5
  },
  islamicCountries: [
    countryCodeEnum.ALGERIA,
    countryCodeEnum.BAHRAIN,
    countryCodeEnum.DJIBOUTI,
    countryCodeEnum.EGYPT,
    countryCodeEnum.IRAN,
    countryCodeEnum.IRAQ,
    countryCodeEnum.ISRAEL,
    countryCodeEnum.ISRAEL,
    countryCodeEnum.JORDAN,
    countryCodeEnum.KUWAIT,
    countryCodeEnum.LEBANON,
    countryCodeEnum.LIBYA,
    countryCodeEnum.MOROCCO,
    countryCodeEnum.MURITANIA,
    countryCodeEnum.OMAN,
    countryCodeEnum.PALESTINE,
    countryCodeEnum.QATAR,
    countryCodeEnum.SAUDI_ARABIA,
    countryCodeEnum.SOMALIA,
    countryCodeEnum.SUDAN,
    countryCodeEnum.SYRIA,
    countryCodeEnum.TUNISIA,
    countryCodeEnum.TURKEY,
    countryCodeEnum.UAE,
    countryCodeEnum.YEMEN,
  ],
  getAccountTypeLabel(country, accountType) {
    var isIslamicCountries = this.islamicCountries.includes(country)
    var isSwapFree = this.islamicAccountTypeMaps[accountType]
    // 包含swap-free字眼
    if (isIslamicCountries && isSwapFree) {
      return this.islamicAccountTypeMaps[accountType]
    } else {
      return this.accountTypeMaps[accountType]
    }
  },
}
